import { GRUSHKA_ORGANIZATION_ID } from '@app/access/constants/organizations';
import { ANATOLY_PRODUCTION_ID } from '@app/access/constants/users';
import { config } from '@app/config';

export const getOnlyAnatolyAccess = (
  database: string | null,
  userId: number | null
) => {
  const { mode } = config;

  if (mode !== 'production') {
    return true;
  }

  return (
    database === GRUSHKA_ORGANIZATION_ID && userId === ANATOLY_PRODUCTION_ID
  );
};
